import { trans } from '@spotahome/soyuz/client';
import './Hero.scss';

const HERO_IMAGES = [
  'https://static.spotahome.com/images/how-it-works/image-1.jpg',
  'https://static.spotahome.com/images/how-it-works/image-2.jpg',
  'https://static.spotahome.com/images/how-it-works/image-3.jpg'
];

const Hero = () => {
  return (
    <section className="hiw-hero">
      <h1 className="hiw-hero__title">
        {trans('ambassador.looking_for_you.hiw.title')}
      </h1>
      <div className="hiw-hero__images">
        {HERO_IMAGES.map(src => (
          <img key={src} className="hiw-hero__images__item" src={src} alt="" />
        ))}
      </div>
    </section>
  );
};

export default Hero;
